<template>
   <div class="dynamic-segments-container">
      <AncillarySeatMapPassengerWrapper :currency="currency" :seat-list="SeatList" :segmentIndex="segment.index" :flightKey="segment.flightKey" :segmentId="segment.id" v-show="!IsMobile" />

      <div class="dynamic-segments-body-wrapper">
         <!-- <button @click="handlerYanyana">ayarla</button> -->
         <!-- <button @click="handlerYanyana">ayarla</button> -->
         <div class="seat-map-generator-informations-container">
            <ul class="seat-map-generator-informations-wrapper">
               <li>
                  <span class="indicator selected"></span>
                  <span class="information">{{ $t("ancillarySeatMap_lblSelected") }}</span>
               </li>
               <li>
                  <span class="indicator available"></span>
                  <span class="information">{{ $t("ancillarySeatMap_lblAvailable") }}</span>
               </li>
               <li>
                  <span class="indicator not-available"></span>
                  <span class="information">{{ $t("ancillarySeatMap_lblNotAvailable") }}</span>
               </li>
               <!-- <li>
                  <span class="indicator extra-leg-room"></span>
                  <span class="information">{{ $t("ancillarySeatMap_lblExtraLegRoom") }}</span>
               </li> -->
            </ul>

            <YanYana :segmentId="segment.id" v-if="IsYanYanaVisible" />
         </div>

         <div class="ancillary-seatmap-passenger-mobile-wrapper">
            <select v-model="selectedOption" @change="handlerSelectOption">
               <option v-for="(pax, paxIndex) in SeatList" :key="paxIndex" :value="pax.paxId" :disabled="pax.initialSeat">
                  <!-- {{ pax }} -->
                  {{ `${pax.paxName} (${pax.paxType})` }} {{ pax.seat != null ? pax.seat : "" }} {{ pax.price | price(currency) }}
               </option>
            </select>
         </div>

         <SeatMapGenerator :currency="currency" :map="segment.rows" />
      </div>
   </div>
</template>

<script>
// import { flightService } from "@/service/index.js";
import AncillarySeatMapPassengerWrapper from "@/components/structural/flight/order-detail/ancillaries/seatmap2/AncillarySeatMapPassengerWrapper.vue";
import SeatMapGenerator from "@/components/structural/flight/order-detail/ancillaries/seatmap2/SeatMapGenerator.vue";
import YanYana from "@/components/structural/flight/order-detail/ancillaries/seatmap2/YanYana.vue";

export default {
   name: "DynamicSegments",
   props: {
      step: Number,
      segment: Object,
      currency: String,
   },
   components: {
      AncillarySeatMapPassengerWrapper,
      SeatMapGenerator,
      YanYana,
   },
   data() {
      return {
         selectedOption: null,
      };
   },
   created() {
      this.$store.dispatch("seatmap/selectFirstPax", this.segment);
      this.$store.commit("seatmap/isModalInitialized", true);
   },
   beforeDestroy() {
      this.handlerSeatControls();
   },

   computed: {
      IsMobile() {
         return this.$store.state.app.clientInformations.isMobile;
      },
      IsYanYanaVisible() {
         const firstPaxObj = this.$store.state.seatmap.segments[this.segment.id].paxes;
         const firstPax = Object.keys(firstPaxObj)[0];
         const seatSelected = firstPaxObj[firstPax].seat != null;
         const hasInfant = this.$store.state.seatmap.hasInfant.status;
         const paxNumber = Object.keys(firstPaxObj).length;
         const selectedPaxId = this.$store.state.seatmap.selectedPax.paxId == firstPax;

         return seatSelected && !hasInfant && paxNumber > 1 && selectedPaxId;
      },
      SeatList() {
         return this.segment.paxes;
      },

      Route() {
         return `${this.segment.departureAirport} - ${this.segment.arrivalAirport}`;
      },

      FlightNumber() {
         return this.segment.flightNumber;
      },

      nameAbbrForMouse() {
         const nameAbbr = this.$store.state.seatmap.selectedPax.nameAbbr;
         const showAbbr = nameAbbr.length != 0 ? true : false;
         return {
            nameAbbr,
            showAbbr,
         };
      },
   },
   methods: {
      handlerSelectOption() {
         console.log("handlerSelectOption", this.SeatList);
         const selected = this.SeatList[this.selectedOption];
         const IsPassengerInfant = selected.paxTypeEnum == 3;
         const InitialSeat = selected.initialSeat;

         if (!IsPassengerInfant && !InitialSeat) {
            this.$store.dispatch("seatmap/updatePaxSelection", selected);
         }
      },
      handlerSeatControls() {
         const self = this;
         // const segmentIndex = self.segment.index;
         const paxes = self.segment.paxes;

         function areAllSeatsAssigned(passengers) {
            for (let key in passengers) {
               if (passengers[key].seat === null && passengers[key].paxTypeEnum != 3) {
                  return false;
               }
            }
            return true;
         }

         if (areAllSeatsAssigned(paxes)) {
            self.$store.commit("seatmap/setStep", { index: self.step, status: true });
         } else {
            self.$store.commit("seatmap/setStep", { index: self.step, status: false });
         }
      },
      handlerYanyana() {
         this.$store.dispatch("seatmap/selectYanyana", this.segment);
      },
   },
   watch: {
      "$store.state.seatmap.selectedPax.paxId": {
         handler: function (paxId) {
            this.selectedOption = paxId;
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.ancillary-seatmap-passenger-mobile-wrapper {
   display: none;
   @media only screen and (max-width: 768px) {
      display: block;
   }
   select {
      border: 2px solid #ccc;
      height: 48px !important;
      width: 100%;
      border-radius: 1rem;
      padding: 0 1rem;
      margin-bottom: 1rem;
   }
}
.dynamic-segments-container {
   display: flex;

   ::v-deep {
      .ancillary-seatmap-passenger-wrapper-container {
         margin-right: 2rem;
         padding-right: 1rem;
         border-right: 8px solid #f4f6fa;
      }
   }

   .dynamic-segments-body-wrapper {
      // border: 1px solid red;
      width: 100%;
      .seat-map-generator-informations-container {
         display: flex;
         align-items: center;
         width: 100%;
         border-bottom: 2px solid #eee;
         margin-bottom: 1rem;
         padding-bottom: 0.5rem;
      }
      .seat-map-generator-informations-wrapper {
         display: flex;
         width: inherit;

         li {
            display: flex;
            align-items: center;
            margin-right: 2rem;

            .indicator {
               display: flex;
               justify-content: center;
               align-items: center;
               border-radius: 4px;
               width: 20px;
               height: 20px;
               margin-right: 0.5rem;

               &.selected {
                  background: var(--primary);
               }
               &.extra-leg-room {
                  background: #c5faca;
                  border-top: 4px solid #37c785;
               }
               &.available {
                  background: #c5faca;
               }
               &.not-available {
                  background: #ebebeb;
                  &::after {
                     content: "x";
                     color: #b5b5b5;
                  }
               }
            }
            .information {
               font-size: 0.85rem;
            }
         }
      }
   }
}
</style>
